import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { ButtonV2 } from '@zola/zola-ui';
import { RenderField } from '../../../common/form';
import { REQUIRED } from '../../../common/form/commonValidations';
import { fetchGuestList, addGuestGroupV2 } from '../../../../actions/GuestActions';

// Utils
import {
  trackGLOnboardSatrted,
  trackGLOnboardStepCompleted,
} from '../../../../util/trackingHelper';
import featureFlags from '../../../../util/featureFlags';

import './NoGuestsOnboardForm.less';

const isGuestListTrackingEvents = featureFlags.get('isGuestListTrackingEvents');

const renderGuests = ({ fields }) =>
  fields.map((guest, index) => (
    <div className="row noguests-onboard__guestRow" key={index}>
      <div className="hidden-xs col-sm-1">
        <i className="zolaicon zolaicon-checkmark" />
      </div>
      <div className="col-xs-6 col-sm-5">
        <Field
          name={`${guest}.first_name`}
          id="add-guest-group-first-name"
          type="text"
          component={RenderField}
          hideFormGroup
          required
          validate={REQUIRED}
        />
      </div>
      <div className="col-xs-6 col-sm-5">
        <Field
          name={`${guest}.family_name`}
          id="add-guest-group-family-name"
          type="text"
          component={RenderField}
          hideFormGroup
          required
          validate={REQUIRED}
        />
      </div>
    </div>
  ));

const NoGuestsOnboardForm = ({ handleSubmit, onAddCoupleAsGuestGroup, submitting, wedding }) => {
  useEffect(() => {
    if (isGuestListTrackingEvents) trackGLOnboardSatrted();
  }, []);

  return (
    <div className="noguests-onboard">
      <div className="container">
        <div className="no-guests-content">
          <h1>Welcome to Your Guest List</h1>
          <p>We&apos;ll add your names and show you around to help you get started!</p>
          <form
            onSubmit={handleSubmit(
              data =>
                new Promise(() => {
                  onAddCoupleAsGuestGroup(data);
                  if (isGuestListTrackingEvents) {
                    trackGLOnboardStepCompleted({
                      step_key: 0,
                      step_name: 'couple_add',
                      questionnaire_version: 1,
                      step_user_response: "Let's Do This",
                    });
                  }
                })
            )}
          >
            <div className="row name-headers">
              <div className="col-xs-6 col-sm-5 col-sm-offset-1">First Name</div>
              <div className="col-xs-6 col-sm-5">Last Name</div>
            </div>
            {wedding && <FieldArray name="guests" component={renderGuests} />}
            <ButtonV2 type="submit" disabled={submitting}>
              Let&apos;s Do This
            </ButtonV2>
          </form>
        </div>
      </div>
    </div>
  );
};

NoGuestsOnboardForm.propTypes = {
  onAddCoupleAsGuestGroup: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  wedding: PropTypes.shape({}),
  initialValues: PropTypes.shape({}),
};
const mapStateToProps = state => {
  const { wedding } = state.wedding;
  return {
    wedding,
    initialValues: {
      event_invitations: [],
      affiliation: 'UNKNOWN',
      country_code: 'US',
      invited: true,
      template: 'SINGLE',
      tier: 'A',
      include_plus_one: 'false',
      guests: [
        {
          first_name: wedding.owner_first_name,
          family_name: wedding.owner_last_name,
          relationship_type: 'PRIMARY',
          source: 'GL_ONBOARDING',
        },
        {
          first_name: wedding.partner_first_name,
          family_name: wedding.partner_last_name,
          relationship_type: 'PARTNER',
          source: 'GL_ONBOARDING',
        },
      ],
      primary_first_name: wedding.owner_first_name,
      primary_family_name: wedding.owner_last_name,
      relationship_type: 'PRIMARY',
      source: 'GL_ONBOARDING',
      partner_family_name: 'lname2',
      partner_first_name: 'fname2',
    },
  };
};

const mapDispatchToProps = dispatch => ({
  onAddCoupleAsGuestGroup: createGuestGroupRequest => {
    dispatch(addGuestGroupV2(createGuestGroupRequest)).then(() => {
      dispatch(fetchGuestList());
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'noGuestsOnboardForm',
  })(NoGuestsOnboardForm)
);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/noGuestsOnboardForm/NoGuestsOnboardForm.jsx